/**
 * Formats a number using the browser's Intl.NumberFormat
 * taking into account the current locale.
 *
 * The current locale is taken from the App.locale property.
 * This is always set in Page.php
 */
export function localizeAndFormat(num: number, options: Intl.NumberFormatOptions = {}): string {
   return new Intl.NumberFormat(jsLocale, options).format(num);
}

const jsLocale = appLocaleToIntlLocale(App?.locale);

function appLocaleToIntlLocale(locale?: string): string | undefined {
   const localeFixed = locale?.replace('_', '-');

   if (!isValidLocale(localeFixed)) {
      return undefined;
   }
   return localeFixed;
}

function isValidLocale(locale?: string): boolean {
   if (!locale) {
      return false;
   }

   try {
      new Intl.Locale(locale);
      return true;
   } catch {
      return false;
   }
}
